import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import cityReducer from "./citySlice"

export const store = configureStore({
  reducer: {
    allCart: cartReducer,
    city: cityReducer,

    
  },
});
 